'use strict'

function initializeHeaderSubnav() {
  $(document).ready(function () {
    // Close nav on click outside
    $('html').on('click', function (event) {
      $('.menu-item--has-children > .link').removeClass('link--active')
    })
    // Prevent header nav to close
    $('.header__primary-nav, .header__secondary-nav, .header__tertiary-nav').on('click', function (event) {
      // event.preventDefault();
      // event.stopPropagation();
    })
    // Toggle Subnav
    $('.menu-item--has-children > .link').on('click', function (event) {
      if ($(this).parents('.header__primary-nav__sub-menu-level-1-columns').length > 0 && $(window).width() > 991) {
      } else {
        event.preventDefault();
        event.stopPropagation();
      }
      if ($(this).hasClass('js-open-corporate-flyout')) {
        $(this).toggleClass('link--active')
      }
      const element = $(this).parent()
      const subNav = element.find('ul').first()
      const navLevel = $(this).parents('ul').length
      // Remove all open classes on first level navigation
      if (navLevel < 2) {
        $('.header__primary-nav ul').removeClass('open')
      }
      if (subNav.hasClass('open')) {
        subNav.removeClass('open')
        $('.header__primary-nav ul li a').removeClass('link--active')
      } else {
        $('.header__primary-nav__sub-menu-level-2, .header__primary-nav__sub-menu-level-2-columns').removeClass('open')
        $('.header__primary-nav ul li a').removeClass('link--active')
        subNav.addClass('open')
        if (navLevel > 1) {
          $(this).addClass('link--active')
        }
      }
    })

    $('.link--js-open-nav').on('click', function (event) {
      event.preventDefault()
      event.stopPropagation()
      const header = $('.header')
      if (header.hasClass('header--mobile-nav-open')) {
        header.removeClass('header--mobile-nav-open')
        $(this).removeClass('active')
      } else {
        $(this).addClass('active')
        header.addClass('header--mobile-nav-open')
      }
    })

    $('.link--js-close-sub-menu').on('click', function (event) {
      event.preventDefault()
      const $this = $(this)
      $this.closest('ul.open').removeClass('open')
    })



    $('.link--js-close-nav').on('click', function (event) {
      event.preventDefault();
      const $this = $(this)
      const header = $('.header')
      $('.link--js-open-nav').removeClass('active')
      $this.parents('ul').removeClass('open')
      header.removeClass('header--mobile-nav-open')
    })

    // Sticky nav scroll observation
    $(window).scroll(stickyNavScroll);
    stickyNavScroll()
    focusSearchInput()
  })

  function stickyNavScroll() {
    const windowTop = $(window).scrollTop()
    const $header = $('.header--sticky')
    const $anchorNav = $('.anchor-nav')
    const headerBottom = $header.outerHeight() + 80

    if (windowTop > headerBottom) {
      $header.addClass('header--scrolled')
      if ($anchorNav.length) {
        $anchorNav.addClass('anchor-nav--sticky-active')
      }
    } else {
      $header.removeClass('header--scrolled')
      if ($anchorNav.length) {
        $anchorNav.removeClass('anchor-nav--sticky-active')
      }
    }
  }

  function focusSearchInput() {
    const search = document.querySelector('[data-flyout="search-flyout"]')
    if (search) {
      search.addEventListener('click', function () {
        window.setTimeout(function () {
          document.getElementById('ke_search_searchfield_sword').focus();
        }, 50);
      })
    }
  }
}

export default initializeHeaderSubnav


